module.exports = __webpack_public_path__ + "static/media/4-8.4198cd03.png";